import {ComponentType, ReactText} from 'react';

import {AnimatedValueTemplate} from '../../DesignSystem/AnimatedNumber/AnimatedNumber';

import {ReactComponent as UKFundingIcon} from '../../../images/icons/poundsTick.svg';
import {ReactComponent as ThumbsUpIcon} from '../../../images/icons/thumbsUp.svg';
import {ReactComponent as EuroTrendsUp} from '../../../images/icons/eurosTrendUp.svg';
import {ReactComponent as CoinsIcon} from '../../../images/icons/coins.svg';
import {ReactComponent as HandshakeIcon} from '../../../images/icons/handshake.svg';
import {ReactComponent as GridGlobeIcon} from '../../../images/icons/gridGlobe.svg';

export type BusinessStatsItemContent =
  | {
      description: string;
      Icon: ComponentType<{className?: string}>;
      stat: ReactText;
      statTemplate: AnimatedValueTemplate;
    }
  | {
      description: string;
      Icon: ComponentType<{className?: string}>;
      title: ReactText;
    };

interface BusinessStatsParams {
  title: string;
  description: string;
}

interface StatParams {
  statValue: string;
  description: string;
  statTemplate: AnimatedValueTemplate;
}

export const ukFunding = ({statTemplate, statValue, description}: StatParams): BusinessStatsItemContent => ({
  Icon: UKFundingIcon,
  stat: statValue,
  statTemplate,
  description,
});

export const customers = ({statTemplate, statValue, description}: StatParams): BusinessStatsItemContent => ({
  Icon: ThumbsUpIcon,
  stat: statValue,
  statTemplate,
  description,
});

export const nlFunding = ({statTemplate, statValue, description}: StatParams): BusinessStatsItemContent => ({
  Icon: EuroTrendsUp,
  stat: statValue,
  statTemplate,
  description,
});

export const totalFundingInMillionsWithEuro = ({
  statTemplate,
  statValue,
  description,
}: StatParams): BusinessStatsItemContent => ({
  Icon: EuroTrendsUp,
  stat: statValue,
  statTemplate,
  description,
});

export const activeInCountries = ({title, description}: BusinessStatsParams): BusinessStatsItemContent => ({
  Icon: GridGlobeIcon,
  title,
  description,
});

export const totalFunding = ({statTemplate, statValue, description}: StatParams): BusinessStatsItemContent => ({
  Icon: CoinsIcon,
  stat: statValue,
  statTemplate,
  description,
});

export const nlPartners = ({statTemplate, statValue, description}: StatParams): BusinessStatsItemContent => ({
  Icon: HandshakeIcon,
  stat: statValue,
  statTemplate,
  description,
});
